/* Schäferhome — Bild-Lightbox der Produktseite.

   Gesteuert wird ein einziger Zustand: der Index des aktiven Bildes plus ein
   Zoomfaktor. Alles andere (Vorschauspalte, Pfeile, Tastatur) schreibt nur
   diesen Zustand und ruft render().

   Zoom-Verhalten unterscheidet sich bewusst nach Eingabegerät:
     Maus  -> Überfahren vergrößert die Stelle unter dem Zeiger
              (transform-origin folgt dem Zeiger)
     Touch -> Zoom-Taste schaltet die Vergrößerung, danach wird gezogen;
              Überfahren gibt es dort nicht.
*/
(function () {
  var lb = document.querySelector('[data-sh-lightbox]');
  if (!lb) return;

  var stage = lb.querySelector('[data-sh-lb-stage]');
  var imgs = Array.prototype.slice.call(lb.querySelectorAll('.sh-lb__img'));
  var thumbs = Array.prototype.slice.call(lb.querySelectorAll('[data-sh-lb-thumb]'));
  if (!imgs.length) return;

  var canHover = window.matchMedia('(hover: hover)').matches;
  var idx = 0;
  var zoom = 1;
  var MIN = 1, MAX = 4, STEP = 0.5;
  var opener = null;
  var panning = false, panX = 0, panY = 0, startX = 0, startY = 0;

  function current() { return imgs[idx]; }

  function render() {
    imgs.forEach(function (im, i) { im.classList.toggle('is-active', i === idx); });
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === idx);
      if (i === idx) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    applyTransform();
    lb.classList.toggle('is-zoomed', zoom > 1);
  }

  function applyTransform(originX, originY) {
    var im = current();
    if (!im) return;
    if (originX != null) im.style.transformOrigin = originX + '% ' + originY + '%';
    im.style.transform = 'scale(' + zoom + ') translate(' + panX + 'px,' + panY + 'px)';
  }

  function go(n) {
    idx = (n + imgs.length) % imgs.length;
    zoom = 1; panX = 0; panY = 0;
    render();
  }

  function setZoom(z) {
    zoom = Math.min(MAX, Math.max(MIN, z));
    if (zoom === 1) { panX = 0; panY = 0; }
    render();
  }

  // ---- Öffnen / Schließen -------------------------------------------------
  function open(startIdx, trigger) {
    opener = trigger || null;
    idx = startIdx || 0;
    zoom = 1; panX = 0; panY = 0;
    lb.hidden = false;
    document.body.classList.add('rb-no-scroll');
    render();
    var close = lb.querySelector('[data-sh-lb-close]');
    if (close) close.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    lb.hidden = true;
    document.body.classList.remove('rb-no-scroll');
    document.removeEventListener('keydown', onKey);
    if (opener && typeof opener.focus === 'function') opener.focus();
  }

  function onKey(e) {
    if (lb.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    else if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var f = lb.querySelectorAll('button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ---- Bedienelemente -----------------------------------------------------
  lb.querySelectorAll('[data-sh-lb-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-sh-lb-thumb'), 10)); });
  });
  var prev = lb.querySelector('[data-sh-lb-prev]');
  var next = lb.querySelector('[data-sh-lb-next]');
  if (prev) prev.addEventListener('click', function () { go(idx - 1); });
  if (next) next.addEventListener('click', function () { go(idx + 1); });
  var zin = lb.querySelector('[data-sh-lb-zoomin]');
  var zout = lb.querySelector('[data-sh-lb-zoomout]');
  if (zin) zin.addEventListener('click', function () { setZoom(zoom + STEP); });
  if (zout) zout.addEventListener('click', function () { setZoom(zoom - STEP); });

  // ---- Maus: Stelle unter dem Zeiger vergrößern ---------------------------
  if (canHover) {
    stage.addEventListener('mouseenter', function () {
      if (zoom === 1) { zoom = 2; lb.classList.add('is-zoomed'); }
    });
    stage.addEventListener('mouseleave', function () {
      zoom = 1; panX = 0; panY = 0; render();
    });
    stage.addEventListener('mousemove', function (e) {
      if (zoom === 1) return;
      var r = stage.getBoundingClientRect();
      applyTransform(
        ((e.clientX - r.left) / r.width) * 100,
        ((e.clientY - r.top) / r.height) * 100
      );
    });
  }

  // ---- Touch: ziehen wenn vergrößert, sonst wischen zum Blättern ----------
  stage.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    startX = e.clientX; startY = e.clientY;
    panning = zoom > 1;
    if (panning) stage.setPointerCapture(e.pointerId);
  });
  stage.addEventListener('pointermove', function (e) {
    if (!panning) return;
    panX += (e.clientX - startX) / zoom;
    panY += (e.clientY - startY) / zoom;
    startX = e.clientX; startY = e.clientY;
    applyTransform();
  });
  stage.addEventListener('pointerup', function (e) {
    if (e.pointerType === 'mouse') return;
    if (panning) { panning = false; return; }
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 45) go(dx < 0 ? idx + 1 : idx - 1);
  });

  // ---- Von der Galerie aus öffnen -----------------------------------------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sh-lb-open]');
    if (!t) return;
    e.preventDefault();
    // Der Auslöser kennt die Medien-ID, nicht die Position: die Galerie zieht
    // je nach Variante ein Bild nach vorne, Positionen stimmen dann nicht mehr.
    var id = t.getAttribute('data-sh-lb-open');
    var hit = imgs.findIndex(function (im) { return im.getAttribute('data-media-id') === id; });
    open(hit > -1 ? hit : 0, t);
  });

  window.schaeferLightbox = { open: open, close: close };
})();
